import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { ServiceBase } from '../../shared/base/service-base';

import { Role } from './role';

@Injectable()
export class RoleService extends ServiceBase<Role> {
  constructor(db: AngularFireDatabase) {
    super(db, '/roles');
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/shared/role.service.ts